var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.5C2 4.46714 4.46714 2 7.5 2C10.5329 2 13 4.46714 13 7.5C13 10.5329 10.5329 13 7.5 13C4.46714 13 2 10.5329 2 7.5ZM6.96826 8.86865H8.04053L8.26465 4.5752H6.74414L6.96826 8.86865ZM6.95068 9.7915C6.80127 9.90283 6.72656 10.0962 6.72656 10.3716C6.72656 10.6353 6.80127 10.8257 6.95068 10.9429C7.10303 11.0601 7.28613 11.1187 7.5 11.1187C7.70801 11.1187 7.88672 11.0601 8.03613 10.9429C8.18848 10.8257 8.26465 10.6353 8.26465 10.3716C8.26465 10.0962 8.18848 9.90283 8.03613 9.7915C7.88672 9.68018 7.70801 9.62451 7.5 9.62451C7.28613 9.62451 7.10303 9.68018 6.95068 9.7915Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertWarning);
export default __webpack_public_path__ + "static/media/ico_alert_warning.139ee4f7990b54388402267ddec22276.svg";
export { ForwardRef as ReactComponent };